var map = {
	"./badania_i_skierowania/infografika_1.jpg": 804,
	"./badania_i_skierowania/infografika_2.jpg": 25357,
	"./badania_i_skierowania/infografika_3.jpg": 86176,
	"./badania_i_skierowania/infografika_4.jpg": 75256,
	"./badania_i_skierowania/infografika_5.jpg": 55494,
	"./badania_i_skierowania/infografika_6.jpg": 5674,
	"./badania_i_skierowania/infografika_7.jpg": 98112,
	"./badania_i_skierowania/infografika_8.jpg": 85803,
	"./badania_i_skierowania/infografika_9.jpg": 39195,
	"./diagnostyka_zespolu_post_covid/infografika_1.jpg": 76520,
	"./diagnostyka_zespolu_post_covid/infografika_2.jpg": 45042,
	"./diagnostyka_zespolu_post_covid/infografika_3.jpg": 57904,
	"./diagnostyka_zespolu_post_covid/infografika_4.jpg": 92697,
	"./diagnostyka_zespolu_post_covid/infografika_5.jpg": 43080,
	"./dobre_praktyki/infografika_1.jpg": 71196,
	"./dobre_praktyki/infografika_2.jpg": 55099,
	"./dobre_praktyki/infografika_3.jpg": 1579,
	"./dobre_praktyki/infografika_4.jpg": 31454,
	"./dobre_praktyki/infografika_5.jpg": 70130,
	"./dobre_praktyki/infografika_6.jpg": 65234,
	"./dobre_praktyki/infografika_7.jpg": 93766,
	"./dobre_praktyki/infografika_8.jpg": 87464,
	"./dobre_praktyki/infografika_9.jpg": 49471,
	"./dzialania_nastepne/infografika_1.jpg": 74410,
	"./dzialania_nastepne/infografika_2.jpg": 98281,
	"./dzialania_nastepne/infografika_3.jpg": 87403,
	"./identyfikacja_schorzenia/infografika_1.jpg": 66363,
	"./identyfikacja_schorzenia/infografika_2.jpg": 77765,
	"./identyfikacja_schorzenia/infografika_3.jpg": 69029,
	"./identyfikacja_schorzenia/infografika_4.jpg": 51008,
	"./identyfikacja_schorzenia/infografika_5.jpg": 15691,
	"./identyfikacja_schorzenia/infografika_6.jpg": 75974,
	"./opieka/infografika_1.jpg": 12287,
	"./opieka/infografika_2.jpg": 52003,
	"./opieka/infografika_3.jpg": 58969,
	"./opieka/infografika_4.jpg": 7243,
	"./opieka/infografika_5.jpg": 13305,
	"./opieka/infografika_6.jpg": 34864,
	"./opieka/infografika_7.jpg": 46803,
	"./planowanie_opieki/infografika_1.jpg": 93904,
	"./planowanie_opieki/infografika_2.jpg": 66872,
	"./pytania_wyroznione/infografika_1.jpg": 78056,
	"./pytania_wyroznione/infografika_2.jpg": 3514,
	"./pytania_wyroznione/infografika_3.jpg": 74002,
	"./pytania_wyroznione/infografika_4.jpg": 11247,
	"./warunkowe_zalecenia/infografika_1.jpg": 52059,
	"./warunkowe_zalecenia/infografika_2.jpg": 12439,
	"./warunkowe_zalecenia/infografika_3.jpg": 14720,
	"./warunkowe_zalecenia/infografika_4.jpg": 70257,
	"./warunkowe_zalecenia/infografika_5.jpg": 34222,
	"./warunkowe_zalecenia/infografika_6.jpg": 90041,
	"./warunkowe_zalecenia/infografika_7.jpg": 1348,
	"./zalecenia_za_interwencja/infografika_1.jpg": 66770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18274;